import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Flex1 = styled.div`
  flex: 1;
`;
export const NewMilesPage = styled(Flex1)`
  display: flex;
  flex-direction: column;
`;
export const NewBoxWrapper = styled(Flex1)`
  display: flex;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;
export const NewBoxRight = styled(Flex1)`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.x8};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    max-width: 100%;
  }
`;
export const NewBoxLeft = styled(Flex1)`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.x8};
  margin-inline-end: ${({ theme }) => theme.spacing.x4};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-inline-end: 0;
  }
`;
export const NewForm = styled.form`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgb(160 163 189 / 10%);
  border-radius: 10px;
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x5}`};
`;

export const PNRAndTicketNumberParent = styled.div`
  display: flex;
  align-items: center;
  div {
    margin-bottom: 0px !important;
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: 25%;
  display: flex;
  justify-content: flex-end;
  margin-inline-start: 0 !important;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 100%;
  }
`;

export const NewBoxLeftButton = styled(Flex1)`
  width: 147px;
  margin: ${({ theme }) => theme.spacing.x4} auto 0;
  font-size: ${({ theme }) => theme.fs.xs};
  @media (max-width: ${({ theme }) => theme.media.md}) {
  }
`;
